// const { Service } = require("../class");
import Service from "../class/Service";

class ProjectService extends Service {
  constructor(ctx) {
    super(ctx);
    this.ctx = ctx;
    this.model = ctx.model.project;
  }

  async getProjectsByQuery(page, size, ch_name) {
    // 查询条件
    let where = {};
    if (ch_name) {
      where["ch_name"] = ch_name;
    }
    let res = await this.model.findAndCountAll({
      where
    });
    // console.log("service")
    // console.log(res);
  }
}

export default ProjectService;
